import React from 'react';
import { Navbar as BootstrapNavbar, Container, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import { useAuth } from '../../contexts/AuthContext';
import { useLocale } from '../../hooks/useLocale';

function Navbar() {
  const { t } = useTranslation();
  const { localizedPath, barePath } = useLocale();
  const { isAuthenticated, logout } = useAuth();
  const logoSrc = `${process.env.PUBLIC_URL}/logo.svg`;
  const isHome = barePath === '/';

  return (
    <BootstrapNavbar bg="dark" variant="dark" expand="lg" className="navbar">
      <Container>
        <BootstrapNavbar.Brand as={Link} to={localizedPath('/')}>
          <img
            src={logoSrc}
            width="28"
            height="28"
            className="navbar-logo"
            alt="Gniark Live"
            decoding="async"
            fetchpriority="high"
          />
          <span className="navbar-brand-text">Gniark Live</span>
        </BootstrapNavbar.Brand>
        
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            {isHome && (
              <Nav.Link as={Link} to={localizedPath('/on-air')}>
                {t('onAir.nav')}
              </Nav.Link>
            )}
            <Nav.Link as={Link} to={localizedPath('/help')}>
              {t('nav.guides')}
            </Nav.Link>
            <LanguageSelector />
            {isAuthenticated ? (
              <>
                <Nav.Link as={Link} to="/dashboard">
                  {t('dashboard.nav.dashboard')}
                </Nav.Link>
                <Nav.Link onClick={logout}>
                  {t('common.logout')}
                </Nav.Link>
              </>
            ) : isHome ? null : (
              <>
                <Nav.Link as={Link} to={localizedPath('/login')} className="ms-2">
                  {t('common.login')}
                </Nav.Link>
                <Nav.Link as={Link} to={localizedPath('/signup')} className="btn btn-warning ms-2 fw-bold text-dark">
                  {t('common.signup')}
                </Nav.Link>
              </>
            )}
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
}

export default Navbar;
